import route from 'marketplace-front-core/middleware/route'

export default route
